import { useEffect, useState } from 'react';
import type { Tab } from 'pos-client/interfaces/tab.ts';

export const useActiveTab = (tabs: Tab[]) => {
  const [activeTab, setActiveTab] = useState('');
  const url = window.location.toString().split('/');

  const keys = tabs.map((tab) => tab.key);
  const found = url.filter((el) => keys.includes(el));

  useEffect(() => {
    if (found && found.length === 1) {
      setActiveTab(found[0]);
    } else {
      setActiveTab(tabs[0].key);
    }
  }, []);

  return { activeTab, setActiveTab };
};
